import React, { useState } from 'react';
import { Label } from 'reactstrap';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, ButtonGroup } from 'reactstrap';
import CustomSwitch from '../../../custom/CustomSwitch';

export default ({
    modal,
    setModal,
    value,
    setValue,
    allowDuplicateLoc,
    setAllowDuplicateLoc,
    action,
    type,
    tower,
    level,
    handleUpdate,
    enableProcess,
    setTempControlled,
    tempSetting,
    setTempSetting,
    uuid,
    setUuid
}) => {

    const toggle = () => setModal(!modal);
    const title =
        type === 'LEVEL' ?
            `FOR TOWER ${tower}` :
            type === 'LOCATION' ?
                `FOR LEVEL ${level}` :
                type === 'SPECIAL' ?
                    'LOCATION' :
                    '';
    const renderLevel = type === 'SPECIAL' ? '' : level;

    const tempControlled = tempSetting && tempSetting !== 'NONE';

    return (
        <Modal isOpen={modal} toggle={toggle} size={'lg'}>
            <ModalHeader>
                {action} {type} {title}
            </ModalHeader>
            <ModalBody>
                <Input
                    type={'text'}
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    className={'d-inline'}
                    style={{ width: '25%' }}
                />
                <h6 className={'d-inline ml-2'}>
                    (Location = {`${renderLevel}${value}`})
                </h6>
                <div className={'d-block mx-2 px-2 text-white'}>-</div>
                <div>
                    <h6 className={'d-inline mr-2'}>Allow Duplicates:</h6>
                    <ButtonGroup className={'d-inline mt-2'}>
                        {
                            [true, false].map((option, i) => (
                                <Button
                                    onClick={() => setAllowDuplicateLoc(option)}
                                    active={option === allowDuplicateLoc}
                                    key={i}
                                >
                                    {option ? 'Yes' : 'No'}
                                </Button>
                            ))
                        }
                    </ButtonGroup>
                </div>
                <div className={'mt-3'}>
                    <h6 className={'d-inline mr-2'}>Temperature Settings: {tempSetting}</h6>
                    <ButtonGroup className={'d-inline mt-2'}>
                        {
                            ['NONE', 'TEMP. CONTROLLED', 'COOLER'].map((option, i) => (
                                <Button
                                    onClick={() => setTempSetting(option)}
                                    active={option === tempSetting}
                                    key={i}
                                >
                                    {option}
                                </Button>
                            ))
                        }
                    </ButtonGroup>
                </div>
                {
                    tempControlled && (
                        <div className={'mt-3'}>
                            <h6>Dickson UUID</h6>
                            <Input
                                type={'text'}
                                style={{ textTransform: 'none' }}
                                value={uuid}
                                onChange={(e) => setUuid(e.target.value)}
                            />
                        </div>
                    )
                }
            </ModalBody>
            <ModalFooter>
                <Button
                    color="primary"
                    disabled={!enableProcess}
                    onClick={() => handleUpdate()}
                >
                    {action}
                </Button>
                {
                    action !== 'CREATE' &&
                    <Button
                        color="danger"
                        onClick={() => handleUpdate('DELETE')}
                    >
                        DELETE
                    </Button>
                }
                <Button color="secondary" onClick={toggle}>Cancel</Button>
            </ModalFooter>
        </Modal>
    );
}


// {
//     type === 'LOCATION' ?
//         <>

//         </> :
//         <div>
//             <CustomSwitch
//                 label={'IS TEMPERATURE CONTROLLED'}
//                 value={tempControlled}
//                 handleSwitch={() => setTempControlled(prev => !prev)}
//             />

//         </div>
// }